document.addEventListener("DOMContentLoaded", function(ev) {

    var ingredientsListContainer = document.querySelectorAll("[data-ingredients-list-secondary-title]");
    ingredientsListContainer.forEach(ctn => {
        ctn.addEventListener("click", () => {
            toggleIngredientsListInfos(ctn);
        });
    }); 

    var ingredientsMenuContainer = document.querySelector("[data-ingredient-list-menu-container]");
    var ingredientsMenu = document.querySelector("[data-ingredient-list-menu]");
    if (ingredientsMenuContainer != undefined && ingredientsMenu != undefined) {
        var sectionIngredientsList = document.querySelectorAll(".ingredients-list");
        
        sectionIngredientsList.forEach((sectionIngredients, index) => {
            var title = sectionIngredients.querySelector("[data-ingredients-list-title]");
            var newParagraph = document.createElement('p');
            newParagraph.textContent = title.textContent;
            newParagraph.id = "menu-" + title.getAttribute('data-ingredients-list-title');
            if (index == 0) {
                newParagraph.classList.add("active");
            }
            ingredientsMenu.appendChild(newParagraph);

            ingredientsMenuContainer.appendChild(sectionIngredients);
        });

        getCurrentActiveAnchorIngredientsList();
    }

    document.querySelectorAll("a").forEach(function(anchor) {
        anchor.addEventListener("click", function (event) {
            // Check if the href contains "#faq"
            if (this.getAttribute("href") === "#faq") {
                event.preventDefault(); // Stop the default anchor behavior

                // Check if the element with ID "faq" exists on the current page
                let faqElement = document.getElementById("faq");

                if (faqElement) {
                    // If the element exists, scroll smoothly to the element
                    faqElement.scrollIntoView({ behavior: "smooth" });
                } else {
                    // If the element does not exist, redirect to the homepage with #faq
                    window.location.href = "/#faq";
                }
            }
        });
    });

    // Redirect to section product
    var btnsRedirectProduct = document.querySelectorAll("[data-btn-redirect-product]");
    // console.log("btnsRedirectProduct ", btnsRedirectProduct);
    btnsRedirectProduct.forEach((btnRedirect) => {
        btnRedirect.addEventListener("click", () => {
            console.log("Click")
            if (document.getElementById('section--featured-subscription') != undefined) {
                document.getElementById('section--featured-subscription').scrollIntoView({ behavior: 'smooth' });
            } else {
                document.location.href = "/#section--featured-subscription";
            }

            // Find the element by its id
            var navigationDrawer = document.getElementById("header-sidebar-menu");

            // Check if the element exists and if it has the "open" attribute
            if (navigationDrawer && navigationDrawer.hasAttribute("open")) {
                // Remove the "open" attribute
                navigationDrawer.removeAttribute("open");
            }
        });
    });

});

function getCurrentActiveAnchorIngredientsList() {
    const sections = document.querySelectorAll('.ingredients-list__container');
    const menuItems = document.querySelectorAll('.ingredients-list-menu__content p');
    const menuContainer = document.querySelector('.ingredients-list-menu__content');

    function removeActiveClasses() {
        menuItems.forEach(item => item.classList.remove('active'));
    }

    function addActiveClass(id) {
        removeActiveClasses();
        const activeItem = document.querySelector(`.ingredients-list-menu__content p#menu-${id}`);
        if (activeItem) {
            activeItem.classList.add('active');
            scrollMenuToActiveItem(activeItem);
        }
    }

    function onScroll() {
        let currentSection = '';
        // On définit la marge de détection (mobile: 180, desktop: 240 pour garder l'avance)
        const detectionOffset = window.innerWidth <= 1024 ? 160 : 240; 
        
        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
            if (pageYOffset >= sectionTop - detectionOffset) { 
                currentSection = section.id;
            }
        });

        if (currentSection) {
            addActiveClass(currentSection);
        }
    }

    function smoothScroll(targetId) {
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
            // Si l'écran est petit (mobile), on utilise 120, sinon (desktop) 220
            const headerOffset = window.innerWidth <= 1024 ? 120 : 220; 
            
            const elementPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;  
            const offsetPosition = elementPosition - headerOffset;
    
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    function scrollMenuToActiveItem(activeItem) {
        if (window.innerWidth <= 1024) { // Application uniquement sur mobile (1024px ou moins)
            const itemOffset = activeItem.offsetLeft - 160;

            menuContainer.scrollTo({
                left: itemOffset,
                behavior: 'smooth'
            });
        }
    }

    menuItems.forEach(item => {
        item.addEventListener('click', function() {
            const targetId = this.id.replace('menu-', '');
            smoothScroll(targetId);
        });
    });

    window.addEventListener('scroll', onScroll);
}

function toggleIngredientsListInfos(ctn) {

    var prt = ctn.closest("[data-ingredients-list-container]");
  
    var descriptionInactive = prt.querySelector("[data-ingredients-list-description].inactive");
    
    document.querySelectorAll("[data-ingredients-list-container]").forEach((container) => {
        hideIngredientsListInfos(container);
    });

    if (descriptionInactive) {
        showIngredientsListInfo(prt);
    }
}

function hideIngredientsListInfos(ctn) {
    ctn.querySelector("[data-ingredients-list-description]").classList.add("inactive");
    ctn.querySelector(".ingredients-list__ingredient-toggle")?.classList.remove("active");
}

function showIngredientsListInfo(ctn) {
    ctn.querySelector("[data-ingredients-list-description]").classList.remove("inactive");
    ctn.querySelector(".ingredients-list__ingredient-toggle")?.classList.add("active");
    
    setTimeout(() => {
        // Mobile: 140, Desktop: 200 (à ajuster si besoin)
        const toggleOffset = window.innerWidth <= 1024 ? 140 : 200; 
        
        let elementTop = ctn.getBoundingClientRect().top + window.pageYOffset - toggleOffset;
        window.scrollTo({
            top: elementTop,
            behavior: 'smooth'
        });
    }, 400);
}